import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'UserList',
  description: '',
  categories: [],
  props: t.object({
  }),
  examples: {
    basic: {
      props: {
      },
      description: ''
    }
  },
  todo: [],
})
